
export const getStringFromArrayParameter = (value: any[], delimiter: string = ','): string => {
  return value.join(delimiter);
};
